// $(document).ready(function () {

//     // accordion
//     let acc = document.getElementsByClassName("accordion");
//     let i;

//     for (i = 0; i < acc.length; i++) {
//         acc[i].addEventListener("click", function () {
//             this.classList.toggle("active");
//             var panel = this.nextElementSibling;
//             if (panel.style.maxHeight) {
//                 panel.style.maxHeight = null;
//             } else {
//                 panel.style.maxHeight = panel.scrollHeight + "px";
//             }
//         });
//     }
// });


$(document).ready(function () {

    // accordion
    let acc = document.getElementsByClassName("accordion");
    let i;
    const panels = document.querySelectorAll('.accordion');

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {

            if (this.classList.contains('active')) {

                panels.forEach(panel => {
                    panel.classList.remove('active');
                    var subPanel = panel.nextElementSibling;
                    if (subPanel.style.maxHeight) {
                        subPanel.style.maxHeight = null;
                    }
                });
            } else {
                panels.forEach(panel => {
                    panel.classList.remove('active');
                    var subPanel = panel.nextElementSibling;
                    if (subPanel.style.maxHeight) {
                        subPanel.style.maxHeight = null;
                    }
                });
                this.classList.add("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            }


        });
    }
});



$(document).ready(function () {
    // agrandir hauteur du textarea comments
    let $textarea = $('.plus-btn textarea');
    let i;
    let $textareaHeight = $textarea.height();
    for (i = 0; i < $textarea.length; i++) {
        $textarea[i].addEventListener("click", function () {
            this.classList.toggle("textarea-active");
        });
    }
});


$(document).ready(function () {

    //form validation

    let screenWidth = $(window).width();
    let emailField = $('#email');
    let submitBtn = $('button');
    let errorMsg = $('#messageBox label');

    $("button").click(function () {

        // errorMsg.html("");

        if (screenWidth > 0) {
            $('form').validate({
                highlight: function (element, errorClass) {
                    // $(element).css("border", "red dotted 3px");
                    $(element).addClass('invalid');
                },
                rules: {
                    email: {
                        required: true,
                        email: true
                    },
                    selecttitle: {
                        required: true
                    },
                    selecthelp: {
                        required: true
                    },
                    practicename: {
                        required: true
                    }
                },
                messages: {
                    email: {
                        required: "Please provide your email address",
                        email: "Your email address must be in the format of name@domain.com"
                    },
                    selecttitle: {
                        required: "Please tell us who you are"
                    },
                    selecthelp: {
                        required: "Please tell us how we can help"
                    },
                    practicename: {
                        required: "Please tell us your practice name"
                    }
                }
            });
        }

    });
});

$(document).ready(function () {

    //mobile overlay
    let $hamburger = "";
    let $close = "<i class='far fa-times-circle'></i>";
    let $open = "<i class='far fa-bars'>";
    let $mobileBtn = $('a#mobile-menu-btn').html();

    $('a#menuToggle').click(function (e) {
        // e.preventDefault();
        $('.mobile-overlay').toggleClass('hide-overlay');
        $('.mobile-overlay').toggleClass('open');
        $('.mobile-overlay').toggleClass('show-overlay');
        $('.mobile-overlay').toggleClass('close');
        // $('a#mobile-menu-btn').html($close);
        $('header').toggleClass('bg-blue');

        $('body').toggleClass('noscroll');
        $('mobile-overlay').scrollTop = 0;

    });

});


$(document).ready(function () {

    // testimonial carousel

    let slideChangeDelay = 5500;

    $h2 = $('#testimonial h2');
    $items = [$('.item1'), $('.item2')];
    $indicators = [$('.nav1'), $('.nav2')];
    $arrowLeft = $('.chevron-left');
    $arrowRight = $('.chevron-right');
    $smArrowLeft = $('.chevron-left .small-chevron');
    $smArrowRight = $('.chevron-right .small-chevron');
    $fullCircle = "<i class='fas fa-circle'></i>";
    $emptyCircle = "<i class='far fa-circle'></i>"
    slideNum = 0;

    var i;
    for (i = 1; i < $items.length; i++) {
        $items[i].css('display', 'none');
    }

    $arrowRight.click(function () {
        changeToRight();
    });
    $smArrowRight.click(function () {
        changeToRight();
    });
    $arrowLeft.click(function () {
        changeToLeft();
    });
    $smArrowLeft.click(function () {
        changeToLeft();
    });

    function changeToRight() {
        if (slideNum < 1) {
            $items[slideNum].css('display', 'none');
            $items[slideNum + 1].css('display', 'unset');
            $indicators[slideNum].html($emptyCircle);
            $indicators[slideNum + 1].html($fullCircle);
            slideNum++;
            // console.log(slideNum);
        } else {
            for (i = 1; i < $items.length; i++) {
                $items[i].css('display', 'none');
                $indicators[i].html($emptyCircle);
            }
            slideNum = 0;
            $items[0].css('display', 'unset');
            $indicators[0].html($fullCircle);
            // $items[0].addClass('opacity');
            // console.log(slideNum);
        }
    }

    function changeToLeft() {
        if (slideNum < 1) {


            for (i = 0; i < $items.length; i++) {
                $items[i].css('display', 'none');
                $indicators[i].html($emptyCircle);
            }
            // Ajust according to the items count
            $items[1].css('display', 'unset');
            $indicators[1].html($fullCircle);
            slideNum = 1;

            console.log(slideNum);
        } else {
            $items[slideNum - 1].css('display', 'unset');
            $items[slideNum].css('display', 'none');
            $indicators[slideNum - 1].html($fullCircle);
            $indicators[slideNum].html($emptyCircle);
            slideNum--;
            console.log(slideNum);
        }
    }
    window.setInterval(function () {
        changeToRight();
    }, slideChangeDelay);
});

$(document).ready(function () {
    let $top = $(document).scrollTop();
    let $header = $('header');
    let $logo = $('#logo img');
    let screenWidth = $(window).width();

    // Ajust header after scrolling
    if (screenWidth > 774) {
        if ($top < 50) {
            $header.removeClass('scroll');
            $logo.removeClass('scroll');
        }
        if ($top > 51) {
            $header.addClass('scroll');
            $logo.addClass('scroll');
        }
    }
});

$(document).scroll(function () {
    let scroll = $(document).scrollTop();
    let $header = $('header');
    let $logo = $('#logo img');
    let screenWidth = $(window).width();

    // shrink header

    if (screenWidth > 774) {
        if (scroll > 20) {
            console.log('allo');
            $header.addClass('scroll');
            $logo.addClass('scroll');
        } else {
            $header.removeClass('scroll');
            $logo.removeClass('scroll');
        }
    } else {
        $header.addClass('bluebg')
    }
    // else {
    //     if (scroll > 150) {
    //         $header.addClass('scroll');
    //         $logo.addClass('scroll');
    //     } else {
    //         $header.removeClass('scroll');
    //         $logo.removeClass('scroll');
    //     }
    // }
});

$(document).ready(function () {
    //easter egg
    $date = "{{ date }}"
    $logo = $('.logo-footer img');
    $copyright = $('.copyright p');
    $logo.hover(
        function () {
            $copyright.html("<p>&copy; 2019 VetLocum Inc. 🤟 All rights reserved</p>");
        },
        function () {
            $copyright.html("<p>&copy; 2019 VetLocum Inc. All rights reserved</p>");
        })

});

$(document).ready(function () {
    // form validation
    var forms = document.querySelectorAll('.validate');
    for (var i = 0; i < forms.length; i++) {
        forms[i].setAttribute('novalidate', true);
    }

    // document.addEventListener('blur', function (event) {
    //     if (!event.target.form.classList.contains('validate')) return;


    // }, true);

});